<template>
  <el-dialog :title="$t('businessDatabusManage.add')" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-form ref="form" :model="addBusinessDatabusInfo" label-width="120px" label-position="right">
      <el-form-item :label="$t('businessDatabusManage.name')" prop="databusName" :rules="[
        { required: true, message: $t('businessDatabusManage.nameRequired'), trigger: 'blur' },
        { max: 128, message: $t('businessDatabusManage.nameTooLong'), trigger: 'blur' }
      ]">
        <el-input v-model="addBusinessDatabusInfo.databusName" :placeholder="$t('businessDatabusManage.inputName')" />
      </el-form-item>
      <el-form-item :label="$t('businessDatabusManage.businessType')" prop="businessTypeCd" :rules="[
        { required: true, message: $t('businessDatabusManage.businessTypeRequired'), trigger: 'blur' }
      ]">
        <el-input v-model="addBusinessDatabusInfo.businessTypeCd"
          :placeholder="$t('businessDatabusManage.inputBusinessType')" />
      </el-form-item>
      <el-form-item :label="$t('businessDatabusManage.adapter')" prop="beanName" :rules="[
        { required: true, message: $t('businessDatabusManage.adapterRequired'), trigger: 'blur' },
        { max: 256, message: $t('businessDatabusManage.adapterTooLong'), trigger: 'blur' }
      ]">
        <el-input v-model="addBusinessDatabusInfo.beanName" :placeholder="$t('businessDatabusManage.inputAdapter')" />
      </el-form-item>
      <el-form-item :label="$t('businessDatabusManage.seq')" prop="seq" :rules="[
        { required: true, message: $t('businessDatabusManage.seqRequired'), trigger: 'blur' },
        { type: 'number', message: $t('businessDatabusManage.seqFormatError'), trigger: 'blur' }
      ]">
        <el-input v-model.number="addBusinessDatabusInfo.seq" :placeholder="$t('businessDatabusManage.inputSeq')" />
      </el-form-item>
      <el-form-item :label="$t('businessDatabusManage.status')" prop="state" :rules="[
        { required: true, message: $t('businessDatabusManage.statusRequired'), trigger: 'change' }
      ]">
        <el-select v-model="addBusinessDatabusInfo.state" :placeholder="$t('businessDatabusManage.selectStatus')"
          style="width:100%">
          <el-option :label="$t('businessDatabusManage.inUse')" value="1001" />
          <el-option :label="$t('businessDatabusManage.disabled')" value="2002" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('businessDatabusManage.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveBusinessDatabusInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveBusinessDatabus } from '@/api/dev/businessDatabusApi'

export default {
  name: 'AddBusinessDatabus',
  data() {
    return {
      dialogVisible: false,
      addBusinessDatabusInfo: {
        databusName: '',
        businessTypeCd: '',
        beanName: '',
        seq: '',
        state: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async saveBusinessDatabusInfo() {
      try {
        await this.$refs.form.validate()
        await saveBusinessDatabus(this.addBusinessDatabusInfo)
        this.$emit('refresh')
        this.dialogVisible = false
        this.$message.success(this.$t('businessDatabusManage.addSuccess'))
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>